<template>
  <div id="app">
    <navigation v-if="$route.meta.keepAlive">
      <router-view>
      </router-view>
    </navigation>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <footnav v-show="$route.meta.navShow" v-bind:footerIcon="footerIcon"></footnav>
    <load></load>
  </div>
</template>
<script>
import footnav from "@/components/footnav.vue";
import load from "@/components/loading.vue"
import { selectLoginUrl, wechatcallback, memberInfo } from "@/api/api";
import { Toast } from "mint-ui";
export default {
  name: "App",
  data() {
    return {
      footerIcon: 0
    };
  },
  components: {
    footnav,
    Toast,
    load
  },
  watch: {
    $route(to, from) {
      //获取到的页面路径 根据路径判断到哪个页面后，再更该高亮
      switch (to.path) {
        case "/home":
          this.footerIcon = 0;
          break;
        case "/goods":
          this.footerIcon = 1;
          break;
        case "/car":
          this.footerIcon = 2;
          break;
        case "/myself":
          this.footerIcon = 3;
          break;
        // case "/helpService":
        //   this.footerIcon = 1;
        break;
      }
    }
  },
  beforeCreate () { 
    this.$nextTick(function () {
      // localStorage.setItem('openid', 'oEvWP0RZWmbe2guSJf8shpIkoMdI')
      // localStorage.setItem('openid', 'oEvWP0bmsKnubMZ5lmBDa-1bxdVE')
      // localStorage.setItem('memberId', '10070')
      // localStorage.setItem('openid', 'oEvWP0bMCno7tSxUVMbwqJuyxAig')
      // localStorage.setItem('memberId', '11150')
      // localStorage.setItem('openid', 'oRj6f4hyTJfc3tD9D_ixbauRMt9A')
      // this.setCode()
    })
  },
  mounted() {
    this.resetFontSize()
  },
  methods: {
    // 限制浏览器字体大小调节
    resetFontSize(){
      if (typeof WeixinJSBridge === 'object' && typeof WeixinJSBridge.invoke === 'function') {
        handleFontSize();
      } else {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', handleFontSize, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', handleFontSize);
          document.attachEvent('onWeixinJSBridgeReady', handleFontSize);
        }
      }
      function handleFontSize() {
        WeixinJSBridge.invoke('setFontSizeCallback', {
          'fontSize': 0
        });
        WeixinJSBridge.on('menu:setfont', function () {
          WeixinJSBridge.invoke('setFontSizeCallback', {
            'fontSize': 0
          });
        });
      }
  },
  memberInfo() {
    let member_id = localStorage.getItem("memberId") || "-1";
    let addressId = localStorage.getItem('addressId');
    let open_id = localStorage.getItem('openid')
    if (member_id == "undefined" || member_id == undefined) {
      member_id = "-1"
    }
    memberInfo({ member_id: member_id }).then(res => {
      if (res.code == 200) {
        if (res.data == null) {
          localStorage.removeItem('openid')
          localStorage.removeItem('defaultFarm')
          localStorage.removeItem('defaultFarmName')
          localStorage.removeItem("farm_id")
          this.getLoginCode();
        } else if (res.data != null) {
          if (res.data.open_id.trim() == open_id.trim()) {
            localStorage.setItem("openid", res.data.open_id);
            localStorage.setItem('memberId', res.data.member_id);
            localStorage.setItem('member_phone', res.data.member_phone);
            localStorage.setItem("wx_member_name", res.data.member.member_name)
            localStorage.setItem("wx_member_sex", res.data.member.member_sex)
            this.$store.commit("setOpenid", res.data.open_id);
            // this.$router.push({path:'/home',query:{member_phone: res.data.member_phone}})
            let backUrl = 'https://xugengmini.shinho.net.cn/#' + window.location.href.split('#')[1]
            window.location.replace(backUrl)
            return
          } else {
            localStorage.removeItem('openid')
            localStorage.removeItem('defaultFarm')
            localStorage.removeItem('defaultFarmName')
            localStorage.removeItem("farm_id")
            this.getLoginCode();
          } 
        } 
      } else {
        localStorage.removeItem('openid')
        localStorage.removeItem('defaultFarm')
        localStorage.removeItem('defaultFarmName')
        localStorage.removeItem("farm_id")
        this.getLoginCode();
      }
    });
    },
    setCode() {
      let ua = window.navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i) == 'micromessenger'){
        localStorage.removeItem("code");
        localStorage.removeItem("state"); 
        let url = window.location.href;
        console.log('url',url);
        let openId = localStorage.getItem("openid")
        let codeNum = url.indexOf("code=");
        let stateNum = url.indexOf("&state=");
        let endNum = url.indexOf("#");
        if (codeNum != -1 && stateNum != -1) {
          let codeValue = url.substring(codeNum + 5, stateNum);
          let stateValue = url.substring(stateNum + 7, endNum);
          localStorage.setItem("code", codeValue);
          localStorage.setItem("state", stateValue);
        }
        let code = localStorage.getItem("code");
        let state = localStorage.getItem("state");
        let channel = getQueryString("channel");
        let registrationWay = getQueryString('registrationWay');
        function getQueryString(name) {
            let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            if(window.location.hash.indexOf("?") < 0){
                    return null;
            }
            let r = window.location.hash.split("?")[1].match(reg); 　　
            if (r != null) return decodeURIComponent(r[2]); 
        　　    return null; 
        }
        if (channel !== null) {
          sessionStorage.setItem("channel", channel)
        }
        if (registrationWay !== null) {
          sessionStorage.setItem("registrationWay", registrationWay)
        }
        if (openId) {  
          this.memberInfo() 
          return
        }
        if (!code) {
          this.getLoginCode();
          return
        } else {
          let str_session_id = localStorage.getItem('str_session_id')
          let sessionChannel = channel || localStorage.getItem("channel") || 'y';
          let registration_way = registrationWay || localStorage.getItem("registrationWay") || 'y'
          wechatcallback({
            url: 'xugengmini.shinho.net.cn',
            code: code,
            state: state,
            str_session_id: str_session_id,
            channel: sessionChannel,
            registration_way:registration_way,
          }).then(res => {
            if (res.code == 200) {
              localStorage.setItem("openid", res.data.openid);
              localStorage.setItem('memberId', res.data.memberId);
              localStorage.setItem('addressId', res.data.addressId);
              localStorage.setItem('member_phone', res.data.memberPhone);
              localStorage.setItem("wx_member_name", res.data.member.member_name)
              localStorage.setItem("wx_member_sex", res.data.member.member_sex)
              this.$store.commit("setOpenid", res.data.openid);
              let backUrl = 'https://xugengmini.shinho.net.cn/#' + window.location.href.split('#')[1]
              window.location.replace(backUrl)
              return
            } else {
              if (!openId) {
                localStorage.removeItem('code')
                localStorage.removeItem('state')
              }
            }
          });
        }
      }else{
        localStorage.removeItem("defaultFarm")
        localStorage.removeItem("defaultFarmName")
        localStorage.removeItem("positionAddress")
        localStorage.setItem("memberId", '-1')
      }
    },
    getLoginCode() {
      localStorage.removeItem('memberId');
      localStorage.removeItem('addressId');
      localStorage.removeItem('member_phone');
      let redirectUrl = 'https://xugengmini.shinho.net.cn/#' + window.location.href.split('#')[1]
      selectLoginUrl({
        redirectUrl: redirectUrl
      }).then(res => {
        if (res.code == 200) {
          localStorage.setItem('str_session_id', res.data.strSessionId)
          let url = res.data.url;
          window.location = url;
        }
      });
    }
  }
}; 
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
body {
    -webkit-text-size-adjust: 100% !important;
}
li {
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue